/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Answers/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Answer from './Answer/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Answers({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/Answers"
  
}) {
let leadMetadataAnswersValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.answers',
})
let leadQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'questions',
})
let aggregateData = fromHelpers.questionsAndAnswers(leadMetadataAnswersValueData, leadQuestionsValueData)
  return (<React.Fragment
>
<div
  data-testid="Answers.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(aggregateData) && aggregateData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="answer"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Answer(${item?.id ?? item?._id ?? index})`}
      >
<Answer
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Answer(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }